import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  DeleteContractMutation,
  DeleteContractMutationVariables
} from './__generated__/DeleteContractMutation'

const mutation: TypedDocumentNode<
  DeleteContractMutation,
  DeleteContractMutationVariables
> = gql`
  mutation DeleteContractMutation($input: DeleteContractInput!) {
    deleteContract(input: $input) {
      status
    }
  }
`

export function deleteContractMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      DeleteContractMutation,
      DeleteContractMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
